module.exports = __webpack_public_path__ + "img/78-2a72e9.png";